<template>
  <div class="w-100 d-flex full-height flex-column justify-content-center text-center bg-clock" v-if="milestone">
    <h1>{{ milestone.title }}</h1>

    <h4>{{ relative }}</h4>

    <ul class="list-unstyled" v-if="!! diffs.length">
      <li v-for="diff in diffs" :key="diff.distance">
        {{ diff.label }}
      </li>
    </ul>

    <h4 class="text-muted">{{ milestone.date.toDateString() }} {{ milestone.date.getHours() > 0 ?
      milestone.date.toLocaleTimeString() : '' }}</h4>

  </div>
</template>

<script>
  import store from '../store/store'
  import relativeDate from '../utils/relativeDate'

  import differenceInMonths from 'date-fns/difference_in_months'
  import differenceInWeeks from 'date-fns/difference_in_weeks'
  import differenceInDays from 'date-fns/difference_in_days'

  export default {
    computed: {
      milestone () {
        return store.state.milestones.find(item => {
          return item.slug === this.$route.params.slug
        })
      },
      relative () {
        return relativeDate(this.milestone.date)
      },
      diffs () {
        const date = this.milestone.date
        return [
          {
            distance: 'month',
            value: differenceInMonths(date, new Date()).toString().replace('-', ''),
          },
          {
            distance: 'week',
            value: differenceInWeeks(date, new Date()).toString().replace('-', ''),
          },
          {
            distance: 'day',
            value: differenceInDays(date, new Date()).toString().replace('-', ''),
          },
        ].filter(duration => {
          return duration.value !== '0' && ! this.relative.includes(duration.distance)
        }).map(duration => {
          const plural = duration.value === '1' ? '' : 's';
          const label = `${duration.value} ${duration.distance}${plural}`;

          return {
            ...duration,
            label
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>
